import * as React from 'react';

const SvgIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
    <path d="M480-412.31 60.39-636.15 480-860l420 223.85zm0 156.15L83.39-467.38l62.84-34.47L480-324.46l334.15-177.39L877-467.38zM480-100 83.39-311.23l62.84-34.46L480-168.31l334.15-177.38L877-311.23zm0-380.61 294.92-155.54L480-791.69 185.46-636.15zm.38-155.54"></path>
  </svg>
);

export default React.memo(SvgIcon);
